export const historyArticles = [
  {
    slug: "mastino",
    category: "Storie Scaligere",
    title: "ADÌ 3 ZUGNO A. D. 1351",
    author: "Thomas Donati",
    description:
      "",
    cover: "/articles/storie-scaligere/img/cover-mastino.jpg",
    content: "/articles/storie-scaligere/mastino.md",
  },
  {
    slug: "bastone-comando",
    category: "Storie Scaligere",
    title: "IL BASTONE DI COMANDO ",
    author: "Thomas Donati",
    description:
      "",
    cover: "/articles/storie-scaligere/img/cover-bastone.jpg",
    content: "/articles/storie-scaligere/bastone-comando.md",
  },
  {
    slug: "guasto",
    category: "Storie Scaligere",
    title: "QUELLI DEL GUASTO",
    author: "Thomas Donati",
    description:
      "",
    cover: "/articles/storie-scaligere/img/cover-guasto.jpg",
    content: "/articles/storie-scaligere/guasto.md",
  },
  {
    slug: "organizzazione-cives",
    category: "Storie Scaligere",
    title: "L'ORGANIZZAZIONE MILITARE DEI CIVES A VERONA ",
    author: "Thomas Donati",
    description:
      "",
    cover: "/articles/storie-scaligere/img/cover-cives.jpg",
    content: "/articles/storie-scaligere/organizzazione-cives.md",
  },
  


  // {
  //   slug: "gladio-romano",
  //   category: "Antichità",
  //   title: "Il gladio romano",
  //   author: "Ordine delle Lame Scaligere",
  //   description:
  //     "Origine, evoluzione e utilizzo di una delle armi più rappresentative dell'esercito romano.",
  //   cover: "/articles/categoria1/articolo1/cover.jpg",
  //   content: "/articles/categoria1/articolo1/article.md",
  // },

  // {
  //   slug: "gladiatori",
  //   category: "Antichità",
  //   title: "I gladiatori",
  //   author: "Ordine delle Lame Scaligere",
  //   description:
  //     "Un breve viaggio nel mondo dei gladiatori e delle diverse specialità combattive.",
  //   cover: "/articles/categoria1/articolo2/cover.jpg",
  //   content: "/articles/categoria1/articolo2/article.md",
  // },

  // {
  //   slug: "spada-medievale",
  //   category: "Medioevo",
  //   title: "La spada medievale",
  //   author: "Ordine delle Lame Scaligere",
  //   description:
  //     "Evoluzione e caratteristiche della spada nel corso del Medioevo.",
  //   cover: "/articles/categoria2/articolo3/cover.jpg",
  //   content: "/articles/categoria2/articolo3/article.md",
  // },
];